/**
 * スライダー式診断機能
 */
export function sliderCalc() {
	//読み込み完了時にデフォルトの計算結果を出力
	if ('function' === typeof sliderCalcResult) {
		sliderCalcResult();
	}

	// レンジ入力フォーム
	const rangeItems = document.querySelectorAll('.js-calc-slider__range');

	if (rangeItems.length) {
		rangeItems.forEach(rangeItem => {
			// スライダーの色変更
			if ('function' === typeof rangeSliderColor) {
				rangeSliderColor(rangeItem);
			}

			// 各レンジが入力された場合の処理
			rangeItem.addEventListener('input', function () {
				// 入力したレンジの属性を取得
				const targetID = rangeItem.getAttribute('data-calc-range');

				// 同じ属性のレンジ入力フォームへの処理
				const targetRanges = document.querySelectorAll('[data-calc-range="' + targetID + '"]');

				targetRanges.forEach(targetRange => {
					// valueを同じ値に変更
					targetRange.value = rangeItem.value;
					// スライダーの色変更
					if ('function' === typeof sliderCalcResult) {
						rangeSliderColor(targetRange);
					}
				});

				// 同じ属性のテキスト入力フォームへの処理
				const targetTexts = document.querySelectorAll('[data-calc-text="' + targetID + '"]');
				targetTexts.forEach(targetText => {
					// レンジ入力フォームの値をテキストフォームに代入
					targetText.value = rangeItem.value;
				});
				// 変更された値を元に計算結果を出力
				if ('function' === typeof sliderCalcResult) {
					sliderCalcResult();
				}

				// スライダーの色変更
				if ('function' === typeof rangeSliderColor) {
					rangeSliderColor(rangeItem);
				}
			});
		});
	};
	// テキスト入力フォーム
	const textItems = document.querySelectorAll('.js-calc-slider__text');

	if (textItems.length) {
		textItems.forEach(textItem => {
			// テキストが入力された場合の処理
			textItem.addEventListener('input', function () {
				// 対象のレンジ入力フォームの取得
				const targetID = textItem.getAttribute('data-calc-text');

				// 同じ属性のテキスト入力フォームへの処理
				const targetTexts = document.querySelectorAll('[data-calc-text=' + targetID + ']');
				// レンジ入力フォームの値をテキストフォームに代入
				targetTexts.forEach(targetText => {
					targetText.value = textItem.value;
				});

				// 同じ属性のレンジ入力フォームへの処理
				const targetRanges = document.querySelectorAll('[data-calc-range=' + targetID + ']');
				// レンジ入力フォームの値をテキストフォームに代入
				targetRanges.forEach(targetRange => {
					targetRange.value = textItem.value;

					// スライダーの色変更
					if ('function' === typeof rangeSliderColor) {
						rangeSliderColor(targetRange);
					}
				});

				// 変更された値を元に計算結果を出力
				if ('function' === typeof sliderCalcResult) {
					sliderCalcResult();
				}
			});
		});
	};
};

/**
 * Range Slider Color
 *
 * レンジのスライドに合わせて背景の色を変更
 */
function rangeSliderColor(item) {
	// レンジの色設定
	const activeColor = "#e32c72";
	const inactiveColor = "#e5e5e5";
	// スライドに合わせて色を変更
	const ratio = (item.value - item.min) / (item.max - item.min) * 100;
	item.style.background = `linear-gradient(90deg, ${activeColor} ${ratio}%, ${inactiveColor} ${ratio}%)`;
}

/**
 * Slider Calc Result
 *
 * スライダー式診断機能の結果表示
 */
function sliderCalcResult() {
	/** 返済金額 */

	// 計算に使用する項目をIDから取得
	let calc01 = document.querySelector('[data-calc-text="calc-01"]');
	let calc02 = document.querySelector('[data-calc-text="calc-02"]');
	let calc03 = document.querySelector('[data-calc-text="calc-03"]');

	if (calc01 && calc02 && calc03) {
		// valueの値を取得し計算に使う数値に変換
		calc01 = calc01.value * 10000;
		calc02 = calc02.value;
		calc03 = calc03.value / 100;

		// 計算
		let result01 = Math.ceil(calc01 * calc03 / 12 * (1 + calc03 / 12) ** calc02 / ((1 + calc03 / 12) ** calc02 - 1));
		// カンマ区切りに変換
		result01 = result01.toLocaleString();

		// 結果を出力
		const calcResult01 = document.querySelectorAll('[data-calc-result="calc-result-01"]');
		calcResult01.forEach(calcResult01 => {
			calcResult01.innerText = result01;
		});
	}


	/** 返済期間 */

	// 計算に使用する項目をIDから取得
	let calc04 = document.querySelector('[data-calc-text="calc-04"]');
	let calc05 = document.querySelector('[data-calc-text="calc-05"]');
	let calc06 = document.querySelector('[data-calc-text="calc-06"]');

	if (calc04 && calc05 && calc06) {
		// valueの値を取得し計算に使う数値に変換
		calc04 = calc04.value * 10000;
		calc05 = calc05.value * 10000;
		calc06 = calc06.value / 100;

		// 計算
		const result02 = Math.ceil((calc04 + calc04 * calc06) / calc05);

		// 結果を出力
		const calcResult02 = document.querySelectorAll('[data-calc-result="calc-result-02"]');
		calcResult02.forEach(calcResult02 => {
			calcResult02.innerText = result02;
		});
	}
};
